<template>
  <div :class="['icon-container', position === 'top'?'position-top':'']" @click="onClick">
    <div class="icon-inner">
      <icon-svg :icon-class="iconName" class="icon"></icon-svg>
    </div>
  </div>
</template>

<script>
  export default {
    name: "RightFloatIcon",
    props: {
      iconName: {},
      position: {},
      to: {},
    },
    mounted() {
    },
    methods: {
      onClick() {
        if (this.to) {
          this.$router.push(this.to)
        } else {
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .icon-container {
    z-index: 999;
    position: fixed;
    right: 14px;
    bottom: 85px;
    /*background: rgba(248, 248, 246, 0.84);*/
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    display: flex;
    width: 43px;
    height: 43px;
    background: rgba(252, 145, 83, 0.83);

    align-items: center;
    justify-content: center;

    .icon-inner {
      font-size: 25px;
      /*color: #000;*/
      color: white;
    }

    .icon {
    }
  }

  .position-top {
    bottom: 145px;
  }

</style>
